import { FieldErrors, Resolver } from 'react-hook-form';

import {
  EOfferFormatKey,
  IStoreSettingsFormValues
} from '../../StoreSettings.types';

import {
  MIN_BASE_UNIT_THRESHOLD,
  MIN_DIGITS_WITHOUT_SHORTHAND
} from './AbbreviationsSettingsV2.consts';

const VALIDATED_OFFER_KEYS: EOfferFormatKey[] = [
  EOfferFormatKey.PRODUCTS,
  EOfferFormatKey.ROLLING_OFFER,
  EOfferFormatKey.PROGRESS_BAR,
  EOfferFormatKey.TRIGGERED_POPUP,
  EOfferFormatKey.SPECIAL_OFFER,
  EOfferFormatKey.BALANCE
];

const MAX_DIGITS_ERROR_MESSAGE =
  'Max digits without shorthand must be at least 3';

const BASE_UNIT_THRESHOLD_ERROR_MESSAGE = 'Threshold must be at least 1';

export const abbreviationsFormResolver: Resolver<IStoreSettingsFormValues> = (
  values
) => {
  const offerErrors = VALIDATED_OFFER_KEYS.reduce<Record<string, unknown>>(
    (accumulator, offer) => {
      const entry = values.numberFormat?.[offer];
      const entryError: Record<string, unknown> = {};

      if (
        entry?.quantity &&
        entry.quantity.maxDigitsWithoutShorthand > 0 &&
        entry.quantity.maxDigitsWithoutShorthand < MIN_DIGITS_WITHOUT_SHORTHAND
      ) {
        entryError.quantity = {
          maxDigitsWithoutShorthand: {
            type: 'min',
            message: MAX_DIGITS_ERROR_MESSAGE
          }
        };
      }

      if (
        entry?.time &&
        entry.time.baseUnitThreshold < MIN_BASE_UNIT_THRESHOLD
      ) {
        entryError.time = {
          baseUnitThreshold: {
            type: 'min',
            message: BASE_UNIT_THRESHOLD_ERROR_MESSAGE
          }
        };
      }

      if (Object.keys(entryError).length > 0) {
        accumulator[offer] = entryError;
      }
      return accumulator;
    },
    {}
  );

  const isValid = Object.keys(offerErrors).length === 0;

  return {
    values: isValid ? values : ({} as IStoreSettingsFormValues),
    errors: (isValid
      ? {}
      : { numberFormat: offerErrors }) as FieldErrors<IStoreSettingsFormValues>
  };
};
